module.exports = __webpack_public_path__ + "img/maestro.c649bdda.png";